"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateVenueSuggestionRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const feedback_1 = require("../../constants/feedback");
class CreateVenueSuggestionRequestDto {}
exports.CreateVenueSuggestionRequestDto = CreateVenueSuggestionRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  maxLength: feedback_1.VENUE_SUGGESTION_NAME_MAX_LENGTH
}), __metadata("design:type", String)], CreateVenueSuggestionRequestDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], CreateVenueSuggestionRequestDto.prototype, "comment", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'WGS84 latitude of the pin the user dropped on the map'
}), __metadata("design:type", Number)], CreateVenueSuggestionRequestDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'WGS84 longitude of the pin the user dropped on the map'
}), __metadata("design:type", Number)], CreateVenueSuggestionRequestDto.prototype, "longitude", void 0);
//# sourceMappingURL=CreateVenueSuggestionRequest.dto.js.map